import { useEffect, useRef } from "react";

const LinearSlider = ({ value, setValue }) => {
  const sliderElem = useRef(null);
  const eventStatus = useRef(true);
  useEffect(() => {
    if (sliderElem.current && !sliderElem.current.noUiSlider) {
      window.noUiSlider.create(sliderElem.current, {
        start: [value],
        step: 1,
        connect: [true, false],
        direction: "ltr",
        tooltips: {
          from: function (formattedValue) {
            return formattedValue;
          },
          to: (value) => {
            // return value < 100 && value > 0 ? value - 1 : value;
            return parseInt(value)
          },
        },
        margin: 100,
        range: {
          min: 0,
          max: 100,
        },
      });
      // Update state when the slider value changes
      sliderElem.current.noUiSlider.on("set", (values) => {
        if (eventStatus.current) {
          setValue(values); // values[0] contains the slider value
        }
        eventStatus.current = true;
      });
    }
  }, [value]);

  useEffect(() => {
    // Update the slider value when the `value` prop changes
    if (sliderElem.current && sliderElem.current.noUiSlider) {
      eventStatus.current = false;
      sliderElem.current.noUiSlider.set(value);
    }
  }, [value]);

  return <div ref={sliderElem} className="my-4"></div>;
};

export default LinearSlider;
